// extracted by mini-css-extract-plugin
export default {"no-of-results":"list-renderer__no-of-results--kzFd8","noOfResults":"list-renderer__no-of-results--kzFd8"};